<template>
    <div class="clearfix mb20 itinerary-content">
        <div class="row no-margin">
            <div class="col-md-12">
                <img src="@/assets/img/svg/img_passengers.svg" width="25">
                <h4 class="no-margin  inline-middle pl-3 pr-3">
                    {{ $t('Passengers') }}
                </h4>
            </div>
        </div>
        <div class="bg-white clearfix relative">
            <div class="clearfix flight-pass-list">
                <div v-for="pass in passengers" :key="pass.id" class="fl-pass-info row no-margin mt-3 mb-3">
                    <div class="col-md-6 col-10 no-padding d-flex align-items-center" style="gap: 15px;">
                        <h4 class="pass-image">
                            {{ pass.first_name.substring(0, 1).toUpperCase() + '' +
                                pass.last_name.substring(0, 1).toUpperCase() }}
                        </h4>
                        <div class="inline-block vertical-middle">
                            <span class="no-margin bold">
                                {{ pass.first_name }}
                                {{ pass.last_name }}
                            </span>
                            <p class="clearfix small text-gray capitalize">
                                {{ $t(pass.type) }} -
                                {{ pass.passport_number }}
                                ({{ $t('Passport') }})
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6  col-2 no-padding text-right">
                        <img class="seat-img pull-right" src="@/assets/img/svg/seat-unavailable.svg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Passengers',
    props: ['passengers'],
}
</script>
<style lang="scss" scoped>
.h4,
h4 {
    font-size: 18px;
}
.mb20 {
    margin-bottom: 20px !important;
}
.no-margin {
    margin: 0;
}
.new-bold-light {
    font-weight: 600;
    font-style: normal;
    color: #00667e;
}

.itinerary-content {
    background-color: #fff;
    border-radius: 6px;
    padding-bottom: 5px;
}
.bold {
    font-weight: 500;
    font-style: normal;
}
.fl-pass-info .pass-image,
.pass-spec-container .pass-image {
    background-color: var(--main-color);
    color: #fff;
    font-size: 12px;
    border: 0;
    border-radius: 50%;
    margin: 0 0px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    text-align: center;
    padding: 1;
    width: 40px;
    height: 40px;
    line-height: 35px;
    padding-top: 3px;
}
.fl-pass-info .seat-img {
    width: 35px;
}
</style>